import type { TagVariant } from '@loadsmart/miranda-react'
import { getHexColor } from '@loadsmart/miranda-react/dist/tokens'

/**
 * Maps API shipment tag hex colors to Miranda `Tag` variants and reference token swatches
 */
export const TagColors = {
  neutral: getHexColor('color-background-tertiary')!,
  accent: getHexColor('color-accent-20')!,
  success: getHexColor('color-success-20')!,
  warning: getHexColor('color-warning-20')!,
  danger: getHexColor('color-danger-20')!,
} as const

export const tagColorVariantMap: Record<string, TagVariant> = {
  [TagColors.success]: 'success',
  [TagColors.neutral]: 'neutral',
  [TagColors.warning]: 'warning',
  [TagColors.danger]: 'danger',
  [TagColors.accent]: 'info',
}

export function getTagVariantFromHex(color: string): TagVariant {
  return tagColorVariantMap[color] ?? 'neutral'
}
